import { ToastType } from '@components/Toast';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';
import { handleToast } from '@utils/utils';

import {
  createCollectionFlag,
  deleteCollectionFlag,
  fetchCollectionFlags,
  updateCollectionFlag,
} from './services';
import { collectionFlagStore, setCollectionFlagStore } from './store';
import { CollectionFlag, CollectionFlagPayload } from './types';

let mutationCount = 0;

export const getCollectionFlagsAction = async (customerId: number) => {
  setCollectionFlagStore({ customerId, flags: [] });
  try {
    let startCount: number;
    let flags: CollectionFlag[];
    do {
      startCount = mutationCount;
      flags = await fetchCollectionFlags(customerId);
    } while (
      startCount !== mutationCount &&
      collectionFlagStore.customerId === customerId
    );
    if (collectionFlagStore.customerId === customerId) {
      setCollectionFlagStore('flags', flags);
    }
  } catch (error) {
    handleToast(ToastType.Error, (error as Error).message);
  }
};

export const createCollectionFlagAction = async (
  payload: CollectionFlagPayload,
  source: ChangeTrackingSource,
) => {
  try {
    const flag = await createCollectionFlag(payload, source);
    mutationCount += 1;
    if (collectionFlagStore.customerId === payload.customerId) {
      setCollectionFlagStore('flags', [...collectionFlagStore.flags, flag]);
    }
    return true;
  } catch (error) {
    handleToast(ToastType.Error, (error as Error).message);
    return false;
  }
};

export const updateCollectionFlagAction = async (
  payload: CollectionFlagPayload,
  source: ChangeTrackingSource,
) => {
  try {
    const flag = await updateCollectionFlag(payload, source);
    mutationCount += 1;
    setCollectionFlagStore(
      'flags',
      collectionFlagStore.flags.map((item) =>
        item.id === flag.id ? flag : item,
      ),
    );
    return true;
  } catch (error) {
    handleToast(ToastType.Error, (error as Error).message);
    return false;
  }
};

export const deleteCollectionFlagAction = async (
  id: number,
  source: ChangeTrackingSource,
) => {
  setCollectionFlagStore('deletingFlagId', id);
  try {
    await deleteCollectionFlag(id, source);
    mutationCount += 1;
    setCollectionFlagStore(
      'flags',
      collectionFlagStore.flags.filter((item) => item.id !== id),
    );
    return true;
  } catch (error) {
    handleToast(ToastType.Error, (error as Error).message);
    return false;
  } finally {
    setCollectionFlagStore('deletingFlagId', null);
  }
};
